var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoMessageillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 153,
    viewBox: "0 0 197 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_246_7815)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.9406,
    cy: 117.415,
    rx: 69.5187,
    ry: 13.4111,
    fill: "#6359CF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7046 144.184C137.52 144.184 169.797 111.907 169.797 72.092C169.797 32.2767 137.52 0 97.7046 0C57.8892 0 25.6125 32.2767 25.6125 72.092C25.6125 111.907 57.8892 144.184 97.7046 144.184Z",
    fill: "url(#paint0_linear_246_7815)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_246_7815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.094 48.7884L96.3157 91.9016L34.5378 48.7884L91.0906 9.30558C92.6243 8.23665 94.4488 7.66357 96.3182 7.66357C98.1877 7.66357 100.012 8.23665 101.546 9.30558L112.827 17.1919L115.78 19.2429L145.521 40.0099L148.654 42.2097L158.094 48.7884Z",
    fill: "url(#paint1_linear_246_7815)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2706 84.8921L34.5378 121.678V48.7883L86.2706 84.8921Z",
    fill: "url(#paint2_linear_246_7815)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_246_7815)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.5,
    cy: 47.3493,
    rx: 22.9904,
    ry: 7.38979,
    fill: "#FF4C77",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.366 84.8921L158.098 121.678V48.7883L106.366 84.8921Z",
    fill: "url(#paint3_linear_246_7815)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5378 121.678L91.024 81.5181C92.5699 80.4173 94.4204 79.8257 96.3182 79.8257C98.216 79.8257 100.067 80.4173 101.613 81.5181L158.094 121.678H34.5378Z",
    fill: "url(#paint4_linear_246_7815)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.789 55.7493C135.532 55.7493 137.449 53.8765 137.449 51.2634C137.449 48.6503 135.532 46.7776 132.789 46.7776C130.088 46.7776 128.129 48.6503 128.129 51.2634C128.129 53.8765 130.088 55.7493 132.789 55.7493ZM136.534 45.1661C136.534 42.1175 138.015 40.9416 140.28 39.7657C143.328 38.1978 145.593 35.6283 145.593 31.9699C145.593 26.5259 140.41 22.6933 133.486 22.6933C126.169 22.6933 120.943 27.005 120.42 33.0587L128.825 34.583C129.13 31.7957 130.785 29.7488 133.137 29.7488C135.01 29.7488 136.447 31.0553 136.447 32.8409C136.447 34.6266 134.836 35.6283 133.442 36.5429C130.393 38.5462 129.087 40.8109 129.087 45.1661H136.534Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_246_7815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0654 35.5806C31.5945 40.0108 21.4172 42.738 11 43.6371C12.4076 46.9091 22.4088 63.2876 52.0976 76.7831C52.9002 76.9066 71.4395 68.2821 81.6135 62.3678C81.2678 62.8617 50.0109 51.3603 41.0654 35.5806Z",
    fill: "url(#paint5_linear_246_7815)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.21 53.5058C138.594 53.5058 147.823 44.277 147.823 32.8927C147.823 21.5083 138.594 12.2795 127.21 12.2795C115.825 12.2795 106.597 21.5083 106.597 32.8927C106.597 44.277 115.825 53.5058 127.21 53.5058Z",
    fill: "#5FADB8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.922 61.516C130.42 61.516 132.863 59.1286 132.863 55.7973C132.863 52.466 130.42 50.0786 126.922 50.0786C123.48 50.0786 120.981 52.466 120.981 55.7973C120.981 59.1286 123.48 61.516 126.922 61.516ZM131.697 48.0243C131.697 44.1379 133.585 42.6388 136.472 41.1397C140.358 39.141 143.245 35.8652 143.245 31.2014C143.245 24.2613 136.638 19.3754 127.81 19.3754C118.483 19.3754 111.82 24.872 111.154 32.5895L121.87 34.5327C122.258 30.9794 124.368 28.3699 127.366 28.3699C129.754 28.3699 131.586 30.0355 131.586 32.3119C131.586 34.5882 129.531 35.8652 127.755 37.0312C123.868 39.5851 122.203 42.4722 122.203 48.0243H131.697Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7984 43.7238C41.3625 43.4214 40.8105 43.3398 40.3058 43.503L23.7355 48.864C23.1419 49.0561 22.9304 49.7872 23.3298 50.2665C23.6514 50.6524 24.1779 50.7999 24.6532 50.6371L41.6463 44.8167C42.1258 44.6524 42.2148 44.0127 41.7984 43.7238Z",
    fill: "#B5AFF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.511 50.3263C41.0907 49.9317 40.4875 49.8002 39.9411 49.984L28.4697 53.8447C27.9638 54.0149 27.7852 54.639 28.1244 55.0511C28.4016 55.3877 28.8582 55.5176 29.271 55.377L41.305 51.2796C41.7112 51.1413 41.8239 50.6201 41.511 50.3263Z",
    fill: "#B5AFF3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6681 53.5959C47.2295 53.2446 46.6396 53.1474 46.1115 53.3394L32.8979 58.1418C32.3793 58.3303 32.2232 58.9882 32.6019 59.3896C32.8916 59.6967 33.3365 59.8015 33.7328 59.656L47.5038 54.6026C47.9319 54.4455 48.024 53.8809 47.6681 53.5959Z",
    fill: "#B5AFF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2877 63.5085C51.8815 63.0595 51.2413 62.9059 50.6757 63.1218L43.124 66.0035C42.6603 66.1805 42.4932 66.7509 42.788 67.1501C43.0642 67.5243 43.5567 67.6673 43.9905 67.4994L52.0846 64.3644C52.4337 64.2292 52.5389 63.7861 52.2877 63.5085Z",
    fill: "#B5AFF3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_246_7815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.544 58.4214C162.028 63.7934 174.369 67.1002 187 68.1904C185.293 72.1579 173.166 92.0179 137.167 108.382C136.194 108.532 113.714 98.0739 101.377 90.9025C101.796 91.5013 139.697 77.5552 150.544 58.4214Z",
    fill: "url(#paint6_linear_246_7815)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.655 68.2957C150.184 67.9291 150.853 67.8301 151.465 68.0281L171.558 74.5286C172.278 74.7615 172.534 75.648 172.05 76.2292C171.66 76.6972 171.021 76.8759 170.445 76.6785L149.84 69.6209C149.258 69.4218 149.15 68.6461 149.655 68.2957Z",
    fill: "#B5AFF3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.03 73.6466C144.54 73.1681 145.271 73.0086 145.934 73.2316L159.843 77.9129C160.457 78.1193 160.673 78.876 160.262 79.3757C159.926 79.7839 159.372 79.9413 158.872 79.7709L144.28 74.8025C143.787 74.6348 143.651 74.0028 144.03 73.6466Z",
    fill: "#B5AFF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 78.0885C138.78 77.6627 139.496 77.5448 140.136 77.7775L156.158 83.6008C156.787 83.8294 156.976 84.6271 156.517 85.1138C156.166 85.4861 155.626 85.6132 155.146 85.4368L138.448 79.3092C137.929 79.1187 137.817 78.4342 138.249 78.0885Z",
    fill: "#B5AFF3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.24 86.9757C125.732 86.4313 126.508 86.2451 127.194 86.5069L136.351 90.0011C136.913 90.2157 137.116 90.9073 136.759 91.3915C136.424 91.8452 135.826 92.0186 135.301 91.8149L125.486 88.0136C125.063 87.8497 124.935 87.3123 125.24 86.9757Z",
    fill: "#B5AFF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.217 82.2297C131.759 81.8897 132.428 81.8194 133.028 82.0391L154.127 89.7533C154.801 89.9998 154.964 90.879 154.424 91.3513C154.066 91.6637 153.566 91.7559 153.121 91.5918L131.357 83.5744C130.77 83.3582 130.687 82.5621 131.217 82.2297Z",
    fill: "#B5AFF3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8576 55.7627C56.4106 55.4823 55.859 55.4242 55.3634 55.6055L37.9637 61.9674C37.4076 62.1707 37.2729 62.8957 37.7188 63.2853C38.0138 63.5429 38.4259 63.619 38.7934 63.4836L56.7422 56.8716C57.2263 56.6933 57.2946 56.0368 56.8576 55.7627Z",
    fill: "#B5AFF3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.942 16.9692C156.942 18.3639 155.811 19.4946 154.416 19.4946C153.022 19.4946 151.891 18.3639 151.891 16.9692C151.891 15.5745 153.022 14.4438 154.416 14.4438C155.811 14.4438 156.942 15.5745 156.942 16.9692Z",
    stroke: "url(#paint7_linear_246_7815)",
    strokeWidth: 2.61276
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6755,
    cy: 128.637,
    r: 2.52536,
    stroke: "url(#paint8_linear_246_7815)",
    strokeWidth: 2.61276
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.185,
    cy: 134.658,
    r: 2.52536,
    stroke: "url(#paint9_linear_246_7815)",
    strokeWidth: 2.61276
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1385 23.1967C57.6534 21.0637 60.6873 21.0637 61.2022 23.1967L61.4253 24.1207C61.6093 24.8829 62.2044 25.478 62.9666 25.662L63.8906 25.8851C66.0236 26.4 66.0236 29.4339 63.8906 29.9488L62.9666 30.1718C62.2044 30.3558 61.6093 30.951 61.4253 31.7132L61.2022 32.6372C60.6873 34.7702 57.6534 34.7702 57.1385 32.6372L56.9155 31.7132C56.7315 30.951 56.1363 30.3558 55.3741 30.1718L54.4501 29.9488C52.3171 29.4339 52.3171 26.4 54.4501 25.8851L55.3741 25.662C56.1363 25.478 56.7315 24.8829 56.9155 24.1207L57.1385 23.1967Z",
    fill: "url(#paint10_linear_246_7815)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.822 118.408C167.337 116.275 170.371 116.275 170.886 118.408L171.109 119.332C171.293 120.095 171.888 120.69 172.65 120.874L173.574 121.097C175.707 121.612 175.707 124.646 173.574 125.16L172.65 125.384C171.888 125.568 171.293 126.163 171.109 126.925L170.886 127.849C170.371 129.982 167.337 129.982 166.822 127.849L166.599 126.925C166.415 126.163 165.82 125.568 165.057 125.384L164.133 125.16C162 124.646 162 121.612 164.133 121.097L165.057 120.874C165.82 120.69 166.415 120.095 166.599 119.332L166.822 118.408Z",
    fill: "url(#paint11_linear_246_7815)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5383 104.898C27.8623 104.686 28.9194 105.987 28.441 107.239L27.2111 110.459C26.7328 111.712 25.0778 111.977 24.2321 110.937L22.0582 108.261C21.2125 107.221 21.8105 105.655 23.1345 105.443L26.5383 104.898Z",
    fill: "url(#paint12_linear_246_7815)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.027 51.6328C169.696 50.3335 170.895 49.1628 172.186 49.5256L175.505 50.4582C176.796 50.8209 177.21 52.4451 176.25 53.3816L173.783 55.7893C172.824 56.7259 171.21 56.2724 170.879 54.9731L170.027 51.6328Z",
    fill: "url(#paint13_linear_246_7815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_246_7815",
    x: 5.64888,
    y: 82.2314,
    width: 182.583,
    height: 70.3683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_246_7815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_246_7815",
    x: 31.0542,
    y: 7.66357,
    width: 130.523,
    height: 91.2054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_7815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_7815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_246_7815",
    x: 81.7363,
    y: 18.1865,
    width: 89.5269,
    height: 58.3255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_246_7815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_246_7815",
    x: 0.548963,
    y: 28.6132,
    width: 91.5156,
    height: 62.1059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.168627 0 0 0 0 0.396078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_7815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_7815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_246_7815",
    x: 81.2911,
    y: 56.6795,
    width: 115.234,
    height: 79.5734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.28021,
    dy: 13.0638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.40282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_7815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_7815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_7815",
    x1: 97.1488,
    y1: -23.4749,
    x2: 98.6257,
    y2: 229.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_7815",
    x1: 96.3157,
    y1: 7.66357,
    x2: 96.3157,
    y2: 91.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_246_7815",
    x1: 38.4045,
    y1: 125.424,
    x2: 97.377,
    y2: 113.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_246_7815",
    x1: 110.232,
    y1: 125.424,
    x2: 169.205,
    y2: 113.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_246_7815",
    x1: 43.7727,
    y1: 123.829,
    x2: 127.385,
    y2: 51.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_246_7815",
    x1: 18.6635,
    y1: 53.9182,
    x2: 64.9181,
    y2: 44.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_246_7815",
    x1: 177.708,
    y1: 80.6568,
    x2: 121.621,
    y2: 69.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_246_7815",
    x1: 151.158,
    y1: 21.1948,
    x2: 159.546,
    y2: 18.7203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_246_7815",
    x1: 44.4165,
    y1: 132.863,
    x2: 52.8055,
    y2: 130.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_246_7815",
    x1: 136.926,
    y1: 138.884,
    x2: 145.314,
    y2: 136.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_246_7815",
    x1: 47.9968,
    y1: 42.4049,
    x2: 76.7588,
    y2: 33.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_246_7815",
    x1: 157.68,
    y1: 137.617,
    x2: 186.442,
    y2: 129.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_246_7815",
    x1: 17.6483,
    y1: 108.067,
    x2: 27.9496,
    y2: 115.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_246_7815",
    x1: 173.99,
    y1: 60.1987,
    x2: 180.097,
    y2: 49.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E95F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessageillustration);
export default __webpack_public_path__ + "static/media/No Message illustration.876e14ee8bdebdf89262ed2e0c07b91c.svg";
export { ForwardRef as ReactComponent };